module.exports = __webpack_public_path__ + "static/img/class_8.36685b8f.jpg";